import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/org/$org/keys')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/org/$org/keys', params: { org: params.org } })
  },
})
